import { CounterPill } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import { Col3Col9 } from '../';
import { ISummaryItem } from '../../../models';
import { ErrorWarningDisplay } from './ErrorWarningDisplay';
import { NoValue } from './NoValue';

export const ListItemLayout = styled.ul.attrs<{}>({
	className: 'tws-summary-list-item-ul',
})`
	padding-left: 10px;
`;
ListItemLayout.displayName = 'ListItemLayout';

export class ListSummaryItem extends React.Component<ISummaryItem> {
	public render() {
		const { displayName, value, errors, warnings } = this.props;

		return (
			<Col3Col9 label={displayName} subLabelDisplayData={<CounterPill actualCount={value.length} />}>
				<div className='tws-summary-list-item'>
					<ListItemLayout>{value.length > 0 && value.map((i: string, key: any) => <li key={key}>{i}</li>)}</ListItemLayout>
					<ErrorWarningDisplay errors={errors} warnings={warnings} />
				</div>
				{value.length === 0 && NoValue}
			</Col3Col9>
		);
	}
}
